import { render, staticRenderFns } from "./SurveyFormWrapper.vue?vue&type=template&id=70ebd3a9"
import script from "./SurveyFormWrapper.vue?vue&type=script&lang=js"
export * from "./SurveyFormWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports